<template>
  <div class="about">
    <div class="about-wrapper">
      <h1>「Collectio」は</h1>
      <h1>「本をみんなで読む」ためのサービスです。</h1>

      <div>
        <h5>同じ本を読んでも、その本から学ぶことは人それぞれ違います。</h5>
        <h5>
          Collectioが提案する読書方法「Collective Reading」は、<br />
          そんな人それぞれの問いや学びを持ち寄ることで、<br />
          新しい視点やより深い学びを得ることができる読書方法です。
        </h5>
      </div>
    </div>

    <div class="about-wrapper">
      <h1>「Collective Reading」とは？</h1>
      <div>
        <h4>問いの投稿</h4>
        <h5>
          「Collectio」には、一つの本に紐づけられた問いを投稿する機能があります。
        </h5>
        <h5>
          なぜ自分がこの本を買ったのか、なぜこの本を読もうと思ったのか、何をこの本から学びたいのかを読む前に明確にすることで、読み切るだけの読書になることを防ぐためです。
        </h5>
      </div>
      <div>
        <h4>答えの投稿</h4>
        <h5>
          自分が投稿した問いは、投稿した後でも、内容を書き換えることができます。なので、本を読みながら予め設定しておいた問いに対する答えを見つけることができたら、自分の言葉で入力します。
        </h5>
        <h5>
          もちろん、問いを予め設定しておく必要はなく、本を読みながらメモとしてこの機能を使うこともできます。そのために、本のページ数や行数をメモしておく機能も備わっています。
        </h5>
      </div>
      <div>
        <h4>みんなの問い</h4>
        <h5>
          「Collectio」では、自分が投稿した問いだけでなく、誰かが投稿した問いについても同じように見ることができます。
        </h5>
        <h5>
          他の人の学びや捉え方を自分のものと比べることで、新しい視点でより深い学びを得られるはずです。
        </h5>
      </div>
    </div>

    <div class="about-wrapper">
      <h1>「集合知」を作り出す空間</h1>

      <div>
        <h5>本を読むのが苦手な方も、本が好きな方も、</h5>
        <h5>
          みんなで本を読み、それぞれの学びを持ち寄ることで実現する「集合知」のようなものを作り出す空間に「Collectio」がなることを願っています。
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  mounted() {
    document.body.classList.add("about-bg");
  }
};
</script>

<style lang="scss">
.about-wrapper {
  margin: 50px auto;
  padding: 20px;
  width: 85%;
  text-align: left;
  background-color: rgba(242, 243, 237, 0.85);
  border-radius: 5px;
  color: #2c3e50;
  font-family: "Times New Roman", Times, serif;

  div {
    margin: 30px;
  }
  h1 {
    margin: 20px;
  }
  h4 {
    font-weight: bold;
  }
  h5 {
    line-height: 30px;
    margin: 20px;
  }

  @media screen and (max-width: 560px) {
    margin: 25px auto;
    padding: 7px;
    width: 95%;
    div {
      margin: 10px;
    }
    h1 {
      margin: 27px;
    }
    h4 {
      font-weight: bold;
    }
    h5 {
      line-height: 35px;
      margin: 7px;
    }
  }
}

.about-bg {
  background-image: url("../assets/co-read.jpg");
  background-size: cover;
  background-attachment: fixed;
}
</style>
